<template>
    <div class="flex items-center h-6 justify-center">
        <i class="text-lg" :class="isBusiness ? 'i-mdi-business' : 'i-mdi-user'"/>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps({
    params: {required: true, type: Object}
})

const isBusiness = computed(() => {
    return props.params.value
})

</script>

<style>

</style>